import Vue from "vue";
import Vuex from "vuex";
import app from "./general/app.store";
import map from "./general/map.store";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    map
  }
});
